/**
 * Storybook3dWedding — Whimsical 3D Disney/Pixar animated wedding experience.
 *
 * Registered under id 'exp-wedding-storybook-3d-v1' so that:
 *   1. Direct preview routes (/preview/exp-wedding-storybook-3d-v1) render cleanly via registry.get(templateId).
 *   2. PublicInvitation.tsx routes here via registry.has(templateId).
 *   3. TemplateRenderer renders it by ID.
 *   4. StepTemplate & DraftPreviewModal can preview it via live SceneExperienceRenderer.
 */

import React from 'react';
import { SceneExperienceRenderer } from '@/src/modules/experiences/scene/SceneExperienceRenderer';
import { resolveExperienceManifest } from '@/src/modules/pages/ExperiencePreview';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';

export const META: TemplateMetadata = {
  id: 'exp-wedding-storybook-3d-v1',
  name: 'Storybook 3D Palace Wedding',
  occasionType: 'WEDDING',
  description:
    'Whimsical 3D Pixar & Disney-inspired fairy-tale palace wedding with floating glowing lanterns, starry skies, and joyful character animations.',
  isPremium: true,
  tags: [
    'cinematic',
    'wedding',
    'storybook',
    'pixar',
    'disney',
    '3d',
    'animated',
    'fairytale',
    'enchanted',
    'premium',
    'scroll-experience',
    'ai-native',
  ],
  colorScheme: { primary: '#F97316', accent: '#FBBF24', bg: '#0F172A' },
};

export function Storybook3dWedding({ data, preview }: { data: InvitationData; preview?: boolean }) {
  const manifest =
    (data as any)?.sceneManifest ||
    resolveExperienceManifest('exp-wedding-storybook-3d-v1', data);
  return <SceneExperienceRenderer manifest={manifest} preview={preview} />;
}

registry.register({ metadata: META, component: Storybook3dWedding });
